// extracted by mini-css-extract-plugin
export default {"title":"ChannelInfoTooltip_title__akDoe","arrowIcon":"ChannelInfoTooltip_arrowIcon__rhChr","connection":"ChannelInfoTooltip_connection__MwFZv"};